const {
  GET_PREORDER_SUBSCRIBERS_REQUEST,
  GET_PREORDER_SUBSCRIBERS_SUCCESS,
  PREORDER_SUBSCRIBERS_ERROR,
} = require("../actions/types");

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PREORDER_SUBSCRIBERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PREORDER_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case PREORDER_SUBSCRIBERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
